import { startOfMonth as startOfMonthFns } from 'date-fns';

export default function startOfMonth(date: Date): Date {
  return startOfMonthFns(date);
}
